export const DrawerWidth = 240;
export const NavbarHeight = 50;
